import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { CustomerService } from '../customer.service';
import * as sha1 from 'sha1'

@Component({
  selector: 'pv-reset-password-hash',
  templateUrl: './reset-password-hash.component.html',
  styleUrls: ['./reset-password-hash.component.scss']
})
export class ResetPasswordHashComponent implements OnInit {
  resetForm: FormGroup;
  hash: string;
  errorMessage: string

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {
    this.resetForm = new FormGroup({
      pass1: new FormControl('', [Validators.required, Validators.minLength(6)]),
      pass2: new FormControl('', [Validators.required, Validators.minLength(6)]),
    }, { validators: this.validatePass })

    this.route.params.subscribe(params => this.verify(params.hash))
  }

  verify(hash: string) {
    this.hash = hash;
  }

  validatePass(group: FormGroup): ValidationErrors | null {
    return group.get('pass1').value == group.get('pass2').value
      ? null
      : { pass2: true }
  }

  onSubmit() {
    this.customerService.changePassword(this.hash, sha1(this.resetForm.get('pass1').value))
    .subscribe(({ success, message }: { success: boolean, message: string }) => {
      if (success) {
        this.router.navigate(['/login'])
      } else {
        this.errorMessage = message
      }
    })
  }
}
